module.exports = __webpack_public_path__ + "assets/img/tab-active-img-feature2-f4912620.png";